import { useCachedQuery } from '../../../../../hooks/useCachedQuery';

// Procedimentos de um tratamento, com cache de leitura offline (via useCachedQuery).
export function useProcedures(treatmentId) {
  const url = treatmentId ? `/treatments/${treatmentId}/procedures` : null;

  const { data, isLoading, isStale, updatedAt, error, refetch } = useCachedQuery(url);

  return {
    procedures: data ?? [],
    isLoading,
    isStale,
    updatedAt,
    error,
    refetch,
  };
}
